export function getText(state) {
    let result
    try {
        result = state.locales[state.locale]
    } catch (error) {
        console.info(`Encountered error while getting localized backend texts: ${error.message}`)
    }

    if (result == null) {
        // return empty result
        return {
            process_manager_error_client_closed: null,
            attention: null,
        }
    }

    return result
}

export function getProcessManagerErrorMessage(state) {
    return getText(state).process_manager_error_client_closed
}

export function getAttentionText(state) {
    return getText(state).attention
}



// WEBPACK FOOTER //
// ./src/features/Backend/data/localized/selectors.js